(() => {
  const root = document.querySelector('[data-evolene-quiz]');
  if (!root) return;

  const steps = Array.from(root.querySelectorAll('[data-evq-step]'));
  const progress = root.querySelector('[data-evq-progress]');
  const back = root.querySelector('[data-evq-back]');
  const live = root.querySelector('[data-evq-live]');
  const answers = {};
  const timers = [];
  let current = 0;

  document.documentElement.classList.add('evq-is-open');
  document.body.classList.add('evq-is-open');

  function emit(name, detail = {}) {
    const payload = { event: name, quiz_name: 'evolene_hair_routine', ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(`evolene:${name}`, { detail: payload }));
  }

  function clearTimers() {
    while (timers.length) window.clearTimeout(timers.pop());
  }

  function updateHistory(step) {
    const slug = step.dataset.slug;
    if (!slug) return;
    const url = `${window.location.pathname}${window.location.search}#${slug}`;
    window.history.replaceState(null, '', url);
  }

  function announce(step, index) {
    const title = step.querySelector('h1, h2');
    if (live && title) live.textContent = `Étape ${index + 1} sur ${steps.length} : ${title.textContent.trim()}`;
  }

  function runAnalysis(step) {
    const items = Array.from(step.querySelectorAll('[data-analysis-item]'));
    items.forEach((item) => item.classList.remove('is-complete'));
    items.forEach((item, index) => {
      timers.push(window.setTimeout(() => item.classList.add('is-complete'), 420 + index * 560));
    });
    timers.push(window.setTimeout(() => showStep(current + 1), 3100));
  }

  function showStep(index) {
    if (index < 0 || index >= steps.length) return;
    clearTimers();
    steps[current].classList.remove('is-active');
    current = index;
    const step = steps[current];
    step.classList.add('is-active');
    progress.style.width = `${((current + 1) / steps.length) * 100}%`;
    back.hidden = current === 0 || step.hasAttribute('data-analysis') || current === steps.length - 1;
    updateHistory(step);
    announce(step, current);
    root.scrollTo({ top: 0, behavior: 'smooth' });
    if (step.hasAttribute('data-analysis')) runAnalysis(step);
    if (current === steps.length - 1) emit('quiz_completed', { step: current + 1 });
  }

  function selectedValues(step) {
    return Array.from(step.querySelectorAll('[data-evq-answer].is-selected')).map((button) => button.dataset.value);
  }

  root.addEventListener('click', (event) => {
    const answer = event.target.closest('[data-evq-answer]');
    if (answer) {
      const step = answer.closest('[data-evq-step]');
      const isMulti = step.hasAttribute('data-multi');
      if (isMulti) {
        answer.classList.toggle('is-selected');
        answer.setAttribute('aria-pressed', answer.classList.contains('is-selected') ? 'true' : 'false');
        const selected = selectedValues(step);
        answers[step.dataset.slug] = selected;
        const continueButton = step.querySelector('[data-evq-continue]');
        if (continueButton) continueButton.disabled = selected.length === 0;
      } else {
        step.querySelectorAll('[data-evq-answer]').forEach((button) => {
          button.classList.toggle('is-selected', button === answer);
          button.setAttribute('aria-pressed', button === answer ? 'true' : 'false');
        });
        answers[step.dataset.slug] = answer.dataset.value;
        emit('quiz_answered', { step: current + 1, question: step.dataset.slug });
        timers.push(window.setTimeout(() => showStep(current + 1), 260));
      }
      return;
    }

    const continueButton = event.target.closest('[data-evq-continue]');
    if (continueButton && !continueButton.disabled) {
      const step = continueButton.closest('[data-evq-step]');
      emit('quiz_answered', { step: current + 1, question: step.dataset.slug });
      showStep(current + 1);
      return;
    }

    if (event.target.closest('[data-evq-next]')) {
      showStep(current + 1);
      return;
    }

    if (event.target.closest('[data-evq-back]')) {
      showStep(current - 1);
      return;
    }

    if (event.target.closest('[data-evq-product]')) {
      emit('quiz_product_clicked', { destination: root.dataset.productUrl });
      const destination = new URL(root.dataset.productUrl);
      const source = new URLSearchParams(window.location.search);
      const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid', 'msclkid'];
      allowed.forEach((key) => {
        if (source.has(key)) destination.searchParams.set(key, source.get(key));
      });
      destination.searchParams.set('quiz', 'complete');
      window.location.assign(destination.toString());
    }
  });

  emit('quiz_started', { step: 1 });
  showStep(0);
})();
